import { useState, useEffect } from "react";
import TextSkeleton from "../../components/SkeletonComponents/TextSkeleton";

const TimeInput = (props) => {
  const [minutes, setMinutes] = useState(props.initialMinutesValue || "");
  const [seconds, setSeconds] = useState(props.initialSecondsValue || "");
  const isLoading = props.isLoading;

  useEffect(() => {
    setMinutes(props.initialMinutesValue);
  }, [props.initialMinutesValue]);

  useEffect(() => {
    setSeconds(props.initialSecondsValue);
  }, [props.initialSecondsValue]);

  const handleMinutesChange = (event) => {
    const { value } = event.target;
    if (value.length <= 2) {
      setMinutes(value);
    }
  };

  const handleSecondsChange = (event) => {
    const { value } = event.target;
    if (value.length <= 2) {
      setSeconds(value);
    }
  };

  const handleInputBlur = () => {
    props.onBlur({ minutes: minutes, seconds: seconds });
  };

  return (
    <div className="flex flex-row items-center">
      {!isLoading ? (
        <div className="relative w-[60px]">
          <input
            id={props.id}
            name={props.id}
            autoComplete="off"
            tabIndex={-1}
            className="mt-1 pr-[24px] text-center block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
            placeholder={props.placeholder}
            type="number"
            value={minutes || ""}
            onChange={handleMinutesChange}
            onBlur={handleInputBlur}
            min="0"
            max="59"
            maxLength="2"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.target.blur();
              }
            }}
          />
          <span className="mt-0.5 text-sm text-center block absolute right-0 top-1/2 -translate-y-1/2 pr-3">
            m
          </span>
        </div>
      ) : (
        <TextSkeleton height="38px" className="mt-1 w-[60px]" />
      )}
      <span className="px-1 text-md">:</span>
      {!isLoading ? (
        <div className="relative w-[60px]">
          <input
            id={props.id}
            name={props.id}
            autoComplete="off"
            tabIndex={-1}
            className="mt-1 pr-[24px] text-center block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
            placeholder={props.placeholder}
            type="number"
            value={seconds || ""}
            onChange={handleSecondsChange}
            onBlur={handleInputBlur}
            min="0"
            max="59"
            maxLength="2"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.target.blur();
              }
            }}
          />
          <span className="mt-0.5 mr-1 text-sm text-center block absolute right-0 top-1/2 -translate-y-1/2 pr-3">
            s
          </span>
        </div>
      ) : (
        <TextSkeleton height="38px" className="mt-1 w-[60px]" />
      )}
    </div>
  );
};

export default TimeInput;
